export { OfficialCard } from "QuorumGrassroots/widgets/ReusableComponents/OfficialCard/OfficialCard"
export type {
    Party,
    Official,
    OfficialAction,
    OfficialActionType,
    OfficialCardProps,
} from "QuorumGrassroots/widgets/ReusableComponents/OfficialCard/OfficialCard.types"
